import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';
import '../admin.css';

const NAV = [
  {
    label: '메인',
    items: [
      { id: 'dashboard', label: '홈 대시보드', icon: 'ti-layout-dashboard', path: '/admin/dashboard' },
    ],
  },
  {
    label: '배우 관리',
    items: [
      { id: 'actors', label: '배우 검색', icon: 'ti-users', path: '/admin/talents' },
      { id: 'actor-emails', label: '이메일 추출', icon: 'ti-mail', path: '/admin/talents/emails' },
    ],
  },
  {
    label: '제작사',
    items: [
      { id: 'companies', label: '제작사 목록', icon: 'ti-building', path: '/admin/companies' },
      { id: 'managed-producers', label: '대행 계정', icon: 'ti-id-badge-2', path: '/admin/managed-producers' },
      { id: 'partners', label: '파트너스 관리', icon: 'ti-building-community', path: '/admin/partners' },
    ],
  },
  {
    label: '공고 관리',
    items: [
      { id: 'postings', label: '공고 목록', icon: 'ti-clipboard-list', path: '/admin/postings' },
    ],
  },
  {
    label: '마케팅',
    items: [
      { id: 'ads', label: '광고 관리', icon: 'ti-speakerphone', path: '/admin/ads' },
    ],
  },
  {
    label: '시스템',
    items: [
      { id: 'developer', label: '에러 로그',  icon: 'ti-terminal',          path: '/admin/dev' },
      { id: 'alerts',    label: '이상 보고',  icon: 'ti-shield-exclamation', path: '/admin/dev?tab=alert' },
    ],
  },
];

export default function AdminLayout({ children, pageId }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { adminLogout } = useAdminAuth();

  const handleLogout = () => {
    adminLogout();
    navigate('/admin');
  };

  return (
    <div className="admin-root">
      <div className="admin-shell">
        {/* ── 사이드바 ── */}
        <nav className="admin-sidebar">
          <div className="admin-logo">
            <div className="admin-logo__title">
              <i className="ti ti-movie" aria-hidden="true" />
              CastarAdmin
            </div>
            <div className="admin-logo__sub">어드민 관리 시스템</div>
          </div>

          {NAV.map(section => (
            <div key={section.label} className="admin-nav-section">
              <span className="admin-nav-label">{section.label}</span>
              {section.items.map(item => {
                const active = pageId === item.id ||
                  // 이메일 추출은 /admin/talents 하위라 '배우 검색'과 겹치지 않게 제외한다
                  (item.id === 'actors' && pathname.startsWith('/admin/talents') && pathname !== '/admin/talents/emails') ||
                  (item.id === 'companies' && pathname.startsWith('/admin/companies')) ||
                  (item.id === 'managed-producers' && pathname.startsWith('/admin/managed-producers')) ||
                  (item.id === 'partners' && pathname.startsWith('/admin/partners')) ||
                  (item.id === 'postings'  && pathname.startsWith('/admin/postings'))  ||
                  (item.id === 'ads' && pathname.startsWith('/admin/ads')) ||
                  (item.id === 'developer' && pathname === '/admin/dev' && !window.location.search.includes('tab=alert')) ||
                  (item.id === 'alerts' && pathname === '/admin/dev' && window.location.search.includes('tab=alert'));
                return (
                  <button
                    key={item.id}
                    className={`admin-nav-item${active ? ' active' : ''}`}
                    onClick={() => navigate(item.path)}
                  >
                    <i className={`ti ${item.icon}`} />
                    {item.label}
                  </button>
                );
              })}
            </div>
          ))}

          <div style={{ marginTop: 'auto', padding: '16px 0 0', borderTop: '0.5px solid var(--color-border-tertiary)' }}>
            <button className="admin-nav-item" onClick={handleLogout}>
              <i className="ti ti-logout" />
              로그아웃
            </button>
          </div>
        </nav>

        {/* ── 메인 ── */}
        <main className="admin-main">
          {children}
        </main>
      </div>
    </div>
  );
}
